export default __webpack_public_path__ + "proximanova-extraboldit-webfont.woff2";